module.exports = __webpack_public_path__ + "static/media/thin-arrow-left.021eb3c4.svg";